import { OffersApiClient } from '@fourthwall/services/dist/OffersApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'
import { decodeHtmlEntities } from '@fourthwall/utils/dist/sanitize'

export const useOfferQuery = createQueryHook(OffersApiClient.getOffer, {
  queryKey: ['offer'],
  select: (data) => ({
    ...data,
    name: decodeHtmlEntities(data.name),
  }),
})

export type OfferQueryResponse = Awaited<ReturnType<typeof OffersApiClient.getOffer>>['data']
